/*
  The byte order for values in Modbus data frames is most 
  significant byte of a multi-byte value is sent before the others.
  Endianess: Big-endian
*/

import {crc16modbus} 		from "crc";
import Serial				from "serial";
import {SerialPort}			from "webserial";
import sleep 				from "sleep";


/* exceptions */
const ILLEGAL_FUNCTION = 1;
const ILLEGAL_DATA_ADDRESS = 2;
const ILLEGAL_DATA_VALUE = 3;
const SLAVE_DEVICE_FAILURE = 4;
const ACKNOWLEDGE = 5;
const SLAVE_DEVICE_BUSY = 6;
const NEGATIVE_ACKNOWLEDGE = 7;
const MEMORY_PARITY_ERROR = 8;

/* functions codes */
const READ_COIL_STATUS = 1;
const READ_INPUT_STATUS = 2;
const READ_HOLDING_REGISTERS = 3;
const PRESET_MULTIPLE_REGISTERS = 16;
const READ_INPUT_REGISTER = 4;
const FORCE_SINGLE_COIL = 5;
const PRESET_SINGLE_REGISTER = 6;
const READ_EXCEPTION_STATUS = 7;

/* offsets */
const OFFSET_DEVICE_ADDRESS = 0;
const OFFSET_FUNCTION_CODE = 1;
const OFFSET_DATA_BYTES = 2;
const OFFSET_LENGTH = 4;
const OFFSET_CRC = 6;

//const OFFSET_DEVICE_ADDRESS = 0;
//const OFFSET_FUNCTION_CODE = 1;
const OFFSET_STARTING_ADDRESS = 2;
const OFFSET_NUMBER_OF_REGISTERS = 4;
const OFFSET_BYTE_COUNT = 6;
const OFFSET_DATA = 7;

/*
  http://www.modbus.org/docs/Modbus_over_serial_line_V1.pdf :
  Intervals of up to one second may elapse between characters within the message. Unless the user has configured a longer timeout,
  an interval greater than 1 second means an error has occurred. Some Wide-Area-Network application may require a timeout in the 4
  to 5 second range. 
*/

const TIMEOUT = 500;


class Modbus {
  constructor() {
  }
  wrap(serialPort) {
    /* wrap the serialPort object */    
    this.__serialPort = serialPort;
  }
  async __flush() {
    var reader = this.__serialPort.readable.getReader();

    /* flush queue */
    try {      
      setTimeout(function() {
        reader.releaseLock();
      }, 10);      
      while (true) {        
        const chunk = await reader.read();     
        if (Modbus.logLevel>2) console.log(`flushing ${chunk.value.byteLength} bytes(s)`);
      }
    } catch(e) {
      if (!(e instanceof TypeError))
        throw e;
    }    
  }
  async open(options) {
    await this.__serialPort.open(options);

    /*
        Modbus RTU use 11-bit char, regardless using parity or not. The formula should be : 11 * 1000000 / ( baud_rate ) for one char time, 
        this applies for baud rate <= 19200 bps. For baud rate > 19200 bps, fixed time is used, which are 1750 micro seconds for 3.5 char time, 
        and 750 micro seconds for 1.5 char time    
    */

    /* options.baudRate is a mandatory option */
    if (options.baudRate<=19200)
      this.IFDELAY = Math.ceil((11 * 1000  / ( options.baudRate) ) * 3.5);
    else
      this.IFDELAY = Math.ceil(1.75);

  }
  async close() {
    await this.__serialPort.close();
  }  
  readCoilStatus() {
  }
  readInputStatus() {
  }
  /* length: read number of registers, 1 register = 1 word = 2 bytes */
  async readHoldingRegisters(address, dataAddress, length, byteSwap=false) {        
    if (Modbus.logLevel>2) console.log(`readHoldingRegister(${address}, ${dataAddress}, ${length})`);

    /* inter frame delay */    
    await sleep(this.IFDELAY);

    /*
      always flush serialPort reader, it may contain data 
      for example when a modbus device is connected it could 
      generate transient garbage data
    */
    await this.__flush();

    //var timeout;
    var reader;
    var promise = new Promise(async function(resolve, reject) {
      let uint8Array = new Uint8Array(8);
      let dataView = new DataView(uint8Array.buffer);

      dataView.setUint8(OFFSET_DEVICE_ADDRESS, address);
      dataView.setUint8(OFFSET_FUNCTION_CODE, READ_HOLDING_REGISTERS);
      dataView.setUint16(OFFSET_DATA_BYTES, dataAddress);
      dataView.setUint16(OFFSET_LENGTH, length);
      dataView.setUint16(OFFSET_CRC, crc16modbus(uint8Array.slice(0, OFFSET_CRC).buffer), true);

      const writer = this.__serialPort.writable.getWriter();
      await writer.write(uint8Array.buffer);
      if (Modbus.logLevel>3) console.log(`readHoldingRegister sent bytes: ${uint8Array}`);
      writer.releaseLock();    

      /* slave address: 1byte, function code: 1byte, length byte: 1byte, data, crc: 2byte */
      /* prepare read buffer */
      reader = this.__serialPort.readable.getReader();
      var result = new Uint8Array(1+1+1+length*2+2);
      var received = 0;	 

      try {
        /* wait for response */     
        while (true) {
          /* if we timeout await reader.read() will throw TypeError */         
          const { value, done } = await reader.read();                
          if (Modbus.logLevel>3) console.log(`readHoldingRegister chunk received(chunk.length=${value.byteLength}, response.length=${received+value.byteLength}, totalwaiting=${result.length})`);

          if (done) {
            // |reader| has been canceled.               
            reject( new Error("reader cancelled") );
            break;          
          }                        

          let uint8Array = new Uint8Array(value);          
          if (Modbus.logLevel>3) console.log(uint8Array);

          if (received+uint8Array.length>result.length) {
            reject( new Error("modbus protocol error") );
            break;            
          }

          result.set(uint8Array, received);
          received += uint8Array.length;	  

          /* check response code if we have enough data */
          if (received>=3) {          
            let dataView = new DataView(result.buffer);
            let device_address = dataView.getUint8(0);
            let function_code = dataView.getUint8(1);
            let byte_count = dataView.getUint8(2);            

            if (function_code != READ_HOLDING_REGISTERS) {
              var exception_code = dataView.getUint8(2);                            
              reject( new Error(exception_code) );
              break;
            }          
          }

          if (received==result.length) {         
            let dataView = new DataView(result.buffer);
            let device_address = dataView.getUint8(0);
            let function_code = dataView.getUint8(1);
            let byte_count = dataView.getUint8(2);            

            if (Modbus.logLevel>2) console.log(`readHoldingRegister response(${device_address}, ${function_code}, ${byte_count})`);
            /* first 3bytes: response code,etc. last 2 bytes: crc */
            result = result.slice(3, -2);

            if (byteSwap) {
              for (var i=0, holder; i<result.length; i+=2) {
                holder = result[i];
                result[i] = result[i+1];
                result[i+1] = holder;
              }                        
            }

            resolve(result.buffer);          
            break;
          }                
        } //while
        reader.releaseLock();
        //clearTimeout(timeout);        
      } catch(e) {
        if (e instanceof TypeError) {
          reject( new Error("timeout") );   
        } else {
          //clearTimeout(timeout);        
          //reject( e );
          throw e;
        }
      }     
    }.bind(this));

    var promiseTimeout = new Promise(function(resolve, reject) {
      /*timeout =*/ setTimeout(function() {        
        reader.releaseLock();        
        reject( new Error("timeout"));        
      }, TIMEOUT);
    }.bind(this));

    return Promise.race([promise, promiseTimeout]);
  }
  async presetMultipleRegisters(address, dataAddress, data) {
    if (Modbus.logLevel>2) console.log(`presetMultipleRegisters(${address}, ${dataAddress}, ${data})`);

    /* inter-frame delay */
    await sleep(this.IFDELAY);

    /*
      always flush serialPort reader, it may contain data 
      for example when a modbus device is connected it could 
      generate transient garbage data
    */
    await this.__flush();

    var reader;
    //var timeout;
    var promise = new Promise(async function(resolve, reject) {
      /*
	    REQUEST
	    Slave Address 11
	    Function 10
	    Starting Address Hi 00
	    Starting Address Lo 01
	    No. of Registers Hi 00
	    No. of Registers Lo 02
        data
	    Error Check (LRC or CRC) ––
	  */

      let uint8Array = new Uint8Array(7+2+data.byteLength);
      let dataView = new DataView(uint8Array.buffer);
      dataView.setUint8(OFFSET_DEVICE_ADDRESS, address);
      dataView.setUint8(OFFSET_FUNCTION_CODE, PRESET_MULTIPLE_REGISTERS);
      dataView.setUint16(OFFSET_STARTING_ADDRESS, dataAddress);
      dataView.setUint16(OFFSET_NUMBER_OF_REGISTERS, Math.trunc(data.byteLength/2));
      dataView.setUint8(OFFSET_BYTE_COUNT, data.byteLength);
      uint8Array.set( new Uint8Array(data), OFFSET_DATA);
      dataView.setUint16(OFFSET_DATA+data.byteLength, crc16modbus(uint8Array.slice(0, -2).buffer), true);


      const writer = this.__serialPort.writable.getWriter();
      await writer.write(uint8Array.buffer);
      writer.releaseLock();  

      /* 
          Byte 0 Modbus Device Address
          Byte 1 Function Code / Message Type (0x10)
          Byte 2 Start Register Number (high byte)
          Byte 3 Start Register Number (low byte)
          Byte 4 The number of registers written (high byte)
          Byte 5 The number of registers written (low byte)
          Byte 6 CRC of bytes 1 to 6 (high byte)
          Byte 7 CRC of bytes 1 to 6 (low byte)

          Error response if sg goes wrong
          Error code 1 Byte 0x90
          Exception code 1 Byte 01 or 02 or 03 or 04 
      */      

      /* prepare read buffer */
      reader = this.__serialPort.readable.getReader();      
      var result = new Uint8Array(8);
      var received = 0;


      /* wait for response */
      try {
        while (1) {
          /* if we timeout await reader.read() will throw TypeError */
          const { value, done } = await reader.read();
          if (Modbus.logLevel>3) console.log(`presetMultipleRegisters response received(chunk.length=${value.byteLength}, response.length=${received+value.byteLength}, totalwaiting=${result.length})`);

          if (done) {
            // |reader| has been canceled.               
            reject( new Error("reader cancelled") );
            break;          
          }                        

          let uint8Array = new Uint8Array(value);          
          if (Modbus.logLevel>3) console.log(uint8Array);

          if (received+uint8Array.length>result.length) {
            reject( new Error("modbus protocol error") );
            break;            
          }

          result.set(uint8Array, received);
          received += uint8Array.length;	  

          if (received>=3) {          
            let dataView = new DataView(result.buffer);
            let device_address = dataView.getUint8(0);
            let function_code = dataView.getUint8(1);
            let byte_count = dataView.getUint8(2);
            if (Modbus.logLevel>2) console.log(`readHoldingRegister response(${device_address}, ${function_code}, ${byte_count})`);
            if (function_code != PRESET_MULTIPLE_REGISTERS) {
              var exception_code = dataView.getUint8(2);
              reject( new Error(exception_code) );
              break;
            }          
          }

          if (received==8) {
            let dataView = new DataView(result.buffer);
            let device_address = dataView.getUint8(0);
            let function_code = dataView.getUint8(1);
            let starting_address = dataView.getUint16(2);
            let number_of_registers = dataView.getUint16(4);
            resolve();
            break;                    
          }                
        } //while
        //clearTimeout(timeout);
        reader.releaseLock();  
      } catch(e) {
        if (e instanceof TypeError) {
          reject( new Error("timeout") );
        } else {
          //clearTimeout(timeout);        
          throw e;        
          //reject( e );
        }
      }
    }.bind(this));

    var promiseTimeout = new Promise(function(resolve, reject) {
      /*timeout =*/ setTimeout(function() {        
        reader.releaseLock();        
        reject( new Error("timeout"));
      }, TIMEOUT);
    }.bind(this));

    return Promise.race([promise, promiseTimeout]);    
  }
  readInputRegisters() {
  }
  forceSingleCoil() {
  }
  presetSingleRegister() {
  }
  readExceptionStatus() {
  }
}

Modbus.logLevel = 2;

export default Modbus;